"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridView = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var GridView = function GridView() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M6 .75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75A.75.75 0 01.75 0h4.5A.75.75 0 016 .75zM14.25 0h-4.5A.75.75 0 009 .75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75zm9 0h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75zm-18 9H.75a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5A.75.75 0 005.25 9zm9 0h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75zm9 0h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75zm-18 9H.75a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75zm9 0h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75zm9 0h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75z"
  });
};

exports.GridView = GridView;